/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import * as React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { withNotifications } from '@components/hoc/withNotifications';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { reduxForm } from 'redux-form';
import { InputField, Input, RemoteAutoComplete, RemoteAutoCompleteField } from '@components/form';
import { externalLookupIszr } from '@modules/wantedVehicles/_wantedVehiclesActions';
import { get } from 'lodash';
import { pcrSearchResult, pcrVehicleSearchResult, pcrVehicleWarnings } from './_vehicleEnums';

const validateData = ({ registrationNumber, vinNumber }) => registrationNumber || vinNumber;

const enhance = compose<any, any>(
  withState('showError', 'handleShowError', false),
  withState('vehicle', 'handleVehicle', undefined),
  withNotifications({ externalLookupIszr }),
  withHandlers({
    onSubmit: ({ handleLoader, externalLookupIszrNotify, handleShowError, handleVehicle }) => async formData => {
      handleLoader(true);
      const isValid = validateData(formData);

      handleShowError(!isValid);

      if (!isValid) {
        handleLoader(false);
        return;
      }

      const response = await externalLookupIszrNotify(formData);

      if (response) {
        handleVehicle(response);
      }

      handleLoader(false);
    },
    handleFill: ({ closeItem, changeFieldValue, vehicle }) => () => {
      for (const attribute of Object.keys(vehicle.vehicle)) {
        changeFieldValue(attribute, vehicle.vehicle[attribute]);
      }
      closeItem();
    }
  }),
  reduxForm({
    form: 'module-pcr-iszr-lookup'
  })
);

const View = ({ closeItem, showError, handleSubmit, vehicle, handleFill }) => (
  <div style={{ margin: '15px' }}>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <h4>Pátrání PČR</h4>
        </Row>
        <Row>
          {[{ label: 'Registrační značka *', name: 'registrationNumber' }, { label: 'VIN *', name: 'vinNumber' }].map(
            ({ label, name }) => (
              <Col md={6} key={name}>
                <InputField component={Input} name={name} label={label} />
              </Col>
            )
          )}

          {[
            { name: 'type', label: 'Druh', url: '/metropolis/api/wv/types' },
            { name: 'brand', label: 'Značka', url: '/metropolis/api/wv/brands' },
            { name: 'color', label: 'Barva', url: '/metropolis/api/wv/colors' }
          ].map(({ name, label, url }) => (
            <Col md={4} key={name}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                id={name}
                name={name}
                label={label}
                url={url}
                filterActive={true}
                fullWidth={true}
                labelFunction={o => get(o, 'name')}
              />
            </Col>
          ))}
        </Row>

        {showError && (
          <Row>
            <h5 style={{ color: 'red' }}>Je potřeba vyplnit registrační značku nebo VIN.</h5>
          </Row>
        )}

        {vehicle && (
          <>
            <Row>
              <h4>{get(pcrSearchResult.find(o => o.id === vehicle.searchResult), 'label')}</h4>
            </Row>

            <Row>
              <Col md={4}>
                <Row>
                  <Col>
                    <b>MPZ:</b> {get(vehicle, 'mpz')}
                  </Col>
                </Row>
                <Row>
                  <Col className="grid-system-margin" />
                </Row>
                <Row>
                  <Col>
                    <b>Registrační značka:</b> {get(vehicle, 'vehicle.registrationNumber')}
                  </Col>
                </Row>
                <Row>
                  <Col className="grid-system-margin" />
                </Row>
                <Row>
                  <Col>
                    <b>VIN:</b> {get(vehicle, 'vehicle.vinNumber')}
                  </Col>
                </Row>
                <Row>
                  <Col className="grid-system-margin" />
                </Row>
              </Col>

              <Col md={4}>
                <Row>
                  <Col>
                    <b>Typ:</b> {get(vehicle, 'vehicle.type')}
                  </Col>
                </Row>
                <Row>
                  <Col className="grid-system-margin" />
                </Row>
                <Row>
                  <Col>
                    <b>Značka:</b> {get(vehicle, 'vehicle.brand')}
                  </Col>
                </Row>
                <Row>
                  <Col className="grid-system-margin" />
                </Row>
                <Row>
                  <Col>
                    <b>Model:</b> {get(vehicle, 'model')}
                  </Col>
                </Row>
                <Row>
                  <Col className="grid-system-margin" />
                </Row>
                <Row>
                  <Col>
                    <b>Barva:</b> {get(vehicle, 'vehicle.color')}
                  </Col>
                </Row>
                <Row>
                  <Col className="grid-system-margin" />
                </Row>
              </Col>

              <Col md={4}>
                <Row>
                  <Col>
                    <b>Výsledek hledání:</b>{' '}
                    {get(pcrVehicleSearchResult.find(o => o.id === vehicle.vehicleSearchResult), 'label')}
                  </Col>
                </Row>
                <Row>
                  <Col className="grid-system-margin" />
                </Row>
                <Row>
                  <Col>
                    <b>Varování:</b>{' '}
                    {vehicle.vehicleWarnings
                      .map(v => get(pcrVehicleWarnings.find(o => o.id === v), 'label'))
                      .join(', ')}
                  </Col>
                </Row>
                <Row>
                  <Col className="grid-system-margin" />
                </Row>
                <Row>
                  <Col>
                    <b>Instrukce:</b> {get(vehicle, 'instruction')}
                  </Col>
                </Row>
                <Row>
                  <Col className="grid-system-margin" />
                </Row>
              </Col>
            </Row>
          </>
        )}
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      {vehicle ? (
        <Button label={'Uložit a zavřít'} onClick={handleFill} primary={true} style={{ margin: '15px' }} />
      ) : (
        <Button label={'Hledat'} type="submit" primary={true} style={{ margin: '15px' }} />
      )}
      <Button label={'Zavřít'} onClick={closeItem} style={{ marginTop: '15px' }} />
    </form>
  </div>
);

export const PcrVehicleForm = enhance(View);



// WEBPACK FOOTER //
// ./src/components/vehicle/PcrVehicleForm.tsx